import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OrdersService } from '../../services/orders/orders.service';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { Router } from '@angular/router';
import { Helpers } from '../../../helpers';

@Component({
  selector: 'app-cancel-einvoice',
  templateUrl: './cancel-einvoice.component.html',
  styleUrls: ['./cancel-einvoice.component.scss']
})
export class CancelEInvoiceComponent implements OnInit {

  @Input() selectedId:any;
  @Input() cancelType:any;
  @Output() onCloseBtnClick = new EventEmitter<any>();
  @Output() onRefreshList = new EventEmitter<any>();
  CompanyId:any;

  Reason: any = {
    lable: 'Cancellation Reason',
    formControlName: 'Reason',
    dataField: 'Reason',
    isRequired: true,
    placeholder: 'Select Reason',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  ReasonValue:any;
  ReasonText:any;
  userId:any;

  constructor(
    private orderService: OrdersService,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private router: Router
  ) { }

  ngOnInit() {
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
  }

  getChangedValue(value, data){
    if(value){
      this.ReasonValue = value.value;
      this.ReasonText = value.name;
    } else {
      this.ReasonValue = null;
      this.ReasonText = null;
    }
  }

  GetReasonList(value, isScrollDown = false) {
    this.Reason.isSearch = true;
    let type = 'Order';
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Reason.dropdownList.length / 20) + 1;
    }
    this.orderService.ReasonSelect2(value, pageNo, type).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Reason.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Reason.dropdownList);
        this.Reason = { ...this.Reason, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Reason = { ...this.Reason, dropdownList: [...dropdownList] });
      this.Reason.isSearch = false;
    }).catch(error => {
      this.Reason.isSearch = false;
    })
  }

  Cancel() {
    this.onCloseBtnClick.emit()
  }

  onSaveClick(){
    if (!this.ReasonValue) {
      this.toastr.warning('Please select a reason','Warning');
      return;
    }
    
    Helpers.setLoading(true);
    this._appService.GetByThreeId("Sales","inv_CancleEInvoiceData",this.selectedId,this.CompanyId,this.ReasonText).subscribe(
    (response) => {
      if (response.responceMes == "OK") {
        this.toastr.success("Successfully cancle e-invoice", "Success");
        this.onRefreshList.emit('true');
        this.Cancel();
      } else {
        this.toastr.error(response.responceMes, "Error");
      }
      Helpers.setLoading(false);
    },
    (err) => {
      Helpers.setLoading(false);
      this.toastr.error(err._body.replace(/"/g, ""), "Error");
      }
    );
  }
}
